var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchBox',{ref:"searchbox",attrs:{"label":"Projeto:","placeholder":"Busca Projeto por Nome ou Código","funcaoBuscar":"getProjetosBox"},on:{"selected":_vm.handleSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }